// John Eldhose 20190412
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Paper, Typography } from '@material-ui/core';
import { AddBox } from '@material-ui/icons';
import ReactTable from 'react-table';
import { getRMAs } from '../../Api/getRMAs';

class RMAs extends Component {

  state = {
    loading: true,
    RMAs: []
  }
  componentWillMount() {
    getRMAs()
      .then((rma) => {
        if(rma['status'] === 'true')
          this.setState({ RMAs: rma['data'], loading: false });
        else
          this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
      })
  }

  render() {
    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={1} lg={1} xl={1} >
          </Grid>
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10} >
          <Typography variant='display1'>
            <center><font color='#385687'>
              Return Merchandise Authorization
            </font></center>
          </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
            <Typography variant='body1'>
              <Link to='rmaform'>
                <AddBox color='primary' style={{ fontSize: 40 }} />
              </Link>
            </Typography>
          </Grid>
        </Grid>
        <Paper>
          <ReactTable
            columns={[
              { Header: 'RMA', accessor:'ixBug', width: 75 },
              { Header: 'RMA Title', accessor: 'sTitle' },
              { Header: 'Serial', accessor: 'asseta03', width: 100 },
              { Header: 'Status', accessor: 'sStatus', width: 220 }
            ]}
            loading={this.state.loadin}
            data={this.state.RMAs}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </Paper>
      </div>
    );
  }
}

export default RMAs;



// WEBPACK FOOTER //
// ./src/components/home/RMAs.js